<template>
  <!-- begin:: Aside -->
  <div class="aside" id="kt_aside" ref="kt_aside">
    <!--begin::Primary-->
    <div class="d-flex flex-column align-items-center flex-row-auto" style="height:100%">
      <KTBrand></KTBrand>
      <!--begin::Nav Wrapper-->
      <perfect-scrollbar class="offcanvas-content mr-n5 scroll" style="max-width: 90vh; position: relative;">
        <div class="aside-nav d-flex flex-column align-items-center scroll scroll-pull ps" style=" width: 100%">
          <!--begin::Nav-->
          <ul class="nav flex-column p-0 align-center" role="tablist" style="padding-left:44px">
            <li class="nav-item mb-2">
              <router-link :to="{ name: 'bibliothequeVideos' }" class="nav-link btn btn-clean btn-lg">
                <div class="px-5">{{$t("sidebar.videosMenu")}}</div>
              </router-link>
            </li>
            <li class="nav-item mb-2">
              <router-link :to="{ name: 'bibliothequeParcours' }" class="nav-link btn btn-clean btn-lg">
                <div class="px-3">{{$t("sidebar.coursesMenu")}}</div>
              </router-link>
            </li>
            <li class="nav-item mb-2">
              <router-link :to="{ name: 'bibliothequeThemes' }" class="nav-link btn btn-clean btn-lg">
                <div>{{$t("sidebar.themesMenu")}}</div>
              </router-link>
            </li>
            <div v-if="this.$store.getters.isSuperUser || this.$store.getters.isAdmin">
              <li class="nav-item mb-2">
                <router-link :to="{ name: 'posterVideoUser' }" class="nav-link btn btn-clean btn-lg">
                  <div>{{$t("sidebar.posteVideosMenu")}}</div>
                </router-link>
              </li>
            </div>
          </ul>
          <!--end::Nav-->
        </div>
      </perfect-scrollbar>
      <!--end::Nav Wrapper-->
      <v-spacer></v-spacer>
      <div></div>
      <!--begin::Footer-->
      <div class="aside-footer d-flex flex-column align-items-center flex-column-auto">

        <!--end::Aside Toggle-->
        <div class="aside-nav d-flex flex-column align-items-center flex-column-fluid scroll scroll-pull ps pb-10">
          <ul class="nav flex-column pr-11 align-center" role="tablist">
              <div v-if="this.$store.getters.isAdmin">
                <a
                  href="#"
                  class="nav-link btn btn-clean btn-lg"
                  id="kt_quick_actions_toggle"
                  data-toggle="tooltip"
                  data-placement="right"
                  data-container="body"
                  data-boundary="window"
                  title=""
                  data-original-title="Quick Actions"
                >
                  <div class="px-5">{{$t("sidebar.adminMenu")}}</div>
                </a>
                <KTQuickActions></KTQuickActions>
                <KTQuickPanel></KTQuickPanel>
              </div>
            <!--begin::Item - ACTIONS RAPIDES -->
            <li
              v-if="this.$store.getters.isAdmin"
              class="nav-item mb-2"
              data-placement="right"
              data-container="body"
              data-boundary="window"
            >
              <a
                href="#"
                class="nav-link btn btn-clean btn-lg"
                role="tab"
                data-tab="5"
                id="kt_quick_panel_toggle"
              >
              <div class="px-4">{{$t("sidebar.actionsRapidesMenu")}}</div>
              </a>
            </li>
            <!--end::Item-->
            <div class="custom-mobile">
              <Flag></Flag>
              <KTQuickUser></KTQuickUser>
            </div>
            
          </ul>
        </div>
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Primary-->
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss" scoped>
/* hide default vue-bootstrap tab links */
  .hide-tabs > div:not(.tab-content) {
    display: none;
  }
  
  .scroll.scroll-pull {
    padding-right: 20px !important;
    margin-right: -40px !important;
  }

  @media (max-width: 600px){
    .aside-secondary-enabled .aside {
        width: 50%;
    }
    .btn-lg {
      padding-top: 3px !important;
      padding-bottom: 3px !important;
      width: 100%; 
      display: block;
    }
    .btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {
      height: calc(1em + 1rem + 2px) !important;
    }
    .custom-mobile{
      display: flex;
      flex-direction: row; 
    }
  }
</style>

<script>
import { mapGetters } from "vuex";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTLayoutAsideToggle from "@/assets/js/layout/base/aside-toggle.js";
import KTBrand from "@/view/layout/brand/Brand.vue";
import Flag from "@/view/layout/aside/Flag.vue";
import KTQuickActions from "@/view/layout/extras/offcanvas/QuickActions.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel.vue";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
      tabIndex: 0,
      users: [],
    };
  },
  props: {
    user: Array,
  },
  components: {
    KTBrand,
    KTQuickActions,
    KTQuickUser,
    KTQuickPanel,
    Flag,
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);

      // Init Aside Toggle
      KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle"]);

      // Init Aside Toggle
      KTLayoutAsideToggle.init(this.$refs["kt_aside_toggle_back"]);
    });
  },
  methods: {
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("nav-link")) {
        target = event.target.closest(".nav-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },
  },
};
</script>
